import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';

export interface MarkComplianceItemAsExtendedArgs {
  newDueDate: string;
  reasonForExtension?: string;
  extensionAcknowledgementFile?: FileBasic;
}

interface MarkComplianceItemAsExtendedResponse {
  success: boolean;
}

export async function markComplianceItemAsExtended(
  complianceItemId: string,
  body: MarkComplianceItemAsExtendedArgs
): Promise<MarkComplianceItemAsExtendedResponse> {
  const res = await fetcher(`compliance/${complianceItemId}/extend`, {
    method: 'POST',
    body,
  });

  if (!res.ok) {
    return { success: false };
  }
  return { success: true };
}
